import { BROKERBANS_INQ } from './types';
// eslint-disable-next-line import/prefer-default-export
export var setBrokerBansInqRedux = function (payload) { return ({
    type: BROKERBANS_INQ,
    payload: payload,
}); };
